'use client';
import { Button, SxProps, Theme } from '@mui/material';
import { COLORS } from '../../constants';
import { MaterialIcon } from '../materialIcon';

/**
 * "Cerrar sesión" link at the end of the "Ver más" pages. Body font at medium weight in red, as in customer-mobile:
 * the link variant's heavy heading font made it the loudest thing on the page.
 *
 * @param {() => void} onClick - Usually opens the close session confirmation.
 * @param {SxProps<Theme>} [sx] - Extra styles, e.g. an entrance animation.
 * @return {React.JSX.Element} The rendered LogoutButton component.
 */
export const LogoutButton = ({ onClick, sx }: { onClick: () => void; sx?: SxProps<Theme> }) => (
  <Button
    variant="link"
    onClick={onClick}
    startIcon={<MaterialIcon icon="logout" size={18} aria-hidden="true" />}
    sx={[
      {
        alignSelf: 'center',
        color: COLORS.state.error,
        fontFamily: (theme) => theme.typography.body2.fontFamily,
        fontWeight: 500,
        fontSize: '1rem',
      },
      ...(Array.isArray(sx) ? sx : [sx]),
    ]}
  >
    Cerrar sesión
  </Button>
);
